'use strict';

const TeamTailorJobForm = {
    init: function () {
        const iframes = document.querySelectorAll('.tt-job-form__iframe');
        if (!iframes.length) {
            return;
        }

        window.addEventListener('message', event => {
            // Accept resize messages from TeamTailor
            if (!event.data || typeof event.data !== 'object') {
                return;
            }
            if (event.data.type !== 'teamtailor:resize') {
                return;
            }
            if (event.data.height && event.data.height > 0) {
                const iframesList = document.querySelectorAll('.tt-job-form__iframe');
                iframesList.forEach(iframe => {
                    if (iframe.contentWindow === event.source) {
                        iframe.style.height = Math.ceil(event.data.height) + 'px';
                    }
                });
            }
        }, false);
    }
};

export default TeamTailorJobForm;
